export default "ui-brandName = { -product-name }\nui-callout-closeButton =\n  .aria-label = Close\nui-tabAriaPrefix = Tab:\n";